// @see JS version: assets/scripts/_03_organisms/offer/office-type-enum.js
export enum OfficeType {
  OPEN_SPACE = 'open_space',
  PRIVATE = 'private',
  INDEPENDENT = 'independent',
}
